module.exports = __webpack_public_path__ + "login-bg.3a91b88c7ab0adc51b48251875625817.jpg";